import { render, staticRenderFns } from "./editLog.vue?vue&type=template&id=22a74768&scoped=true"
import script from "./editLog.vue?vue&type=script&lang=js"
export * from "./editLog.vue?vue&type=script&lang=js"
import style0 from "./editLog.vue?vue&type=style&index=0&id=22a74768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a74768",
  null
  
)

export default component.exports